<template>
  <div>
    <b-row class="row-padding">
      <b-col sm="6">
        <InputQuantity
          ref="quantityPurchased"
          id="quantityPurchased"
          :label="labelQuantity()"
          inputClass="form-control input"
          labelBold
          :max="13"
          v-model="productOfPurchaseOnFiscalEdit.productData.quantityPurchased"
          :error="$v.productOfPurchaseOnFiscalEdit.productData.quantityPurchased.$error"
          @input="onChangeQuantityPurchased"
        />
      </b-col>
      <b-col sm="3">
        <SelectWithSearch
          label="Uni. Conversão"
          labelBold
          placeholder="Informe a Uni. Conversão"
          labelBusca="name"
          v-model="productOfPurchaseOnFiscalEdit.productData.unitOfMeasure"
          ref="searchUnitOfMeasure"
          :clearable="false"
          :options="unitOfMeasureCollection"
          :change="changeUnitOfMeasure"
          :search="searchUnitOfMeasure"
        >
          <template slot="options" slot-scope="props">
            <div class="selected" style="text-transform: uppercase">
              {{ props.data.name }} - {{ props.data.acronym }} - ({{
                returnsCharacterOperator(props.data.converterOperator)
              }}
              {{ valorReal(props.data.converter) }})
            </div>
          </template>
          <template slot="no-options"> Selecione uma unidade </template>
          <template slot="selected" slot-scope="props">
            <div class="selected" style="text-transform: uppercase">
              {{ props.data.acronym }}
            </div>
          </template>
        </SelectWithSearch>
      </b-col>
      <b-col sm="3">
        <InputMoney
          ref="discount"
          id="discount"
          label="Desconto"
          inputClass="form-control input"
          labelBold
          :precision="2"
          v-model="productOfPurchaseOnFiscalEdit.productData.discount"
          :error="$v.productOfPurchaseOnFiscalEdit.productData.discount.$error"
        />
      </b-col>
    </b-row>
    <b-row class="row-padding">
      <b-col sm="6">
        <InputMoney
          ref="price"
          id="price"
          label="Valor Unitário"
          inputClass="form-control input"
          labelBold
          v-model="productOfPurchaseOnFiscalEdit.productData.price"
          :error="$v.productOfPurchaseOnFiscalEdit.productData.price.$error"
          :max="14"
        />
      </b-col>
      <b-col sm="6">
        <InputMoney
          ref="totalPrice"
          id="totalPrice"
          label="Total do Item"
          inputClass="form-control input"
          labelBold
          disabled
          :precision="2"
          v-model="productOfPurchaseOnFiscalEdit.productData.totalPrice"
          :error="$v.productOfPurchaseOnFiscalEdit.productData.totalPrice.$error"
        />
      </b-col>
    </b-row>
    <b-row class="row-padding">
      <b-col sm="3">
        <SelectWithSearch
          label="Origem"
          placeholder="Origem"
          labelBusca="codigo"
          v-model="productOfPurchaseOnFiscalEdit.fiscal.values.origem"
          ref="searchOrigem"
          :filterBy="taxFilter"
          :change="changeOrigemSelected"
          :options="origemCollection"
          :search="searchOrigem"
          :error="$v.productOfPurchaseOnFiscalEdit.fiscal.values.origem.$error"
        >
          <template slot="options" slot-scope="props">
            <div class="selected">{{ props.data.codigo }} - {{ props.data.descricao }}</div>
          </template>
          <template slot="no-options"> Selecione uma origem </template>
          <template slot="selected" slot-scope="props">
            <div class="selected">
              {{ props.data.codigo }}
            </div>
          </template>
        </SelectWithSearch>
      </b-col>
      <b-col sm="3">
        <SelectWithSearch
          label="CST"
          placeholder="CST"
          labelBusca="codigo"
          v-model="productOfPurchaseOnFiscalEdit.fiscal.values.cst"
          ref="searchCst"
          :filterBy="taxFilter"
          :change="changeCstSelected"
          :options="cstCollection"
          :search="searchCst"
        >
          <template slot="options" slot-scope="props">
            <div class="selected">{{ props.data.codigo }} - {{ props.data.descricao }}</div>
          </template>
          <template slot="no-options"> Selecione um CST </template>
          <template slot="selected" slot-scope="props">
            <div class="selected">
              {{ props.data.codigo }}
            </div>
          </template>
        </SelectWithSearch>
      </b-col>
      <b-col sm="3">
        <SelectWithSearch
          label="CSOSN"
          labelBusca="codigo"
          placeholder="CSOSN"
          v-model="productOfPurchaseOnFiscalEdit.fiscal.values.csosn"
          ref="searchCSOSN"
          :filterBy="taxFilter"
          :change="changeCsosnSelected"
          :options="csosnCollection"
          :search="searchCsosn"
        >
          <template slot="options" slot-scope="props">
            <div class="selected">{{ props.data.codigo }} - {{ props.data.descricao }}</div>
          </template>
          <template slot="no-options"> Selecione um CST COFINS </template>
          <template slot="selected" slot-scope="props">
            <div class="selected">
              {{ props.data.codigo }}
            </div>
          </template>
        </SelectWithSearch>
      </b-col>
      <b-col sm="3">
        <SelectWithSearch
          label="CFOP"
          placeholder="CFOP"
          labelBusca="codigo"
          v-model="productOfPurchaseOnFiscalEdit.fiscal.values.cfop"
          ref="searchCfop"
          :filterBy="taxFilter"
          :change="changeCfopSelected"
          :options="cfopCollection"
          :search="searchCfop"
          :error="$v.productOfPurchaseOnFiscalEdit.fiscal.values.cfop.$error"
        >
          <template slot="options" slot-scope="props">
            <div class="selected">{{ props.data.codigo }} - {{ props.data.descricao }}</div>
          </template>
          <template slot="no-options"> Selecione um cfop </template>
          <template slot="selected" slot-scope="props">
            <div class="selected">
              {{ props.data.codigo }}
            </div>
          </template>
        </SelectWithSearch>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { round } from 'lodash';
import { mapActions, mapState } from 'vuex';
import { InputMoney, InputQuantity, SelectWithSearch } from '@/components/Form';
import FormatMixin from '@/modules/Application/mixins/FormatMixin';
import MathUtils from '@/reusable/mathUtils';
import { MULTIPLIER } from '../../../../../UnitOfMeasure/enums/UnitOfMeasureConverterOperatorEnum';
import {
  requiredTax,
  numericStringNumber,
  requiredStringNumber,
  requiredTotalStringNumber,
} from '../validations';
import { numberBRToFloat } from '../../../../../../../../core/helpers/formater/number';

export default {
  name: 'product',
  mixins: [FormatMixin],
  components: {
    InputMoney,
    InputQuantity,
    SelectWithSearch,
  },
  validations: {
    productOfPurchaseOnFiscalEdit: {
      fiscal: {
        values: {
          origem: { requiredTax },
          cfop: { requiredTax },
        },
      },
      productData: {
        price: {
          requiredStringNumber,
        },
        totalPrice: {
          requiredTotalStringNumber,
        },
        quantityPurchased: {
          requiredStringNumber,
        },
        discount: {
          numericStringNumber,
        },
      },
    },
  },
  async mounted() {
    await this.setCfopCollectionForProductPurchase({
      supplierId: this.supplierInformation.supplier.id,
    });
  },
  data() {
    return {
      taxFilter(option, search) {
        const temp = search.toLocaleLowerCase();
        return option.descricao.includes(temp) || option.codigo.includes(temp);
      },
    };
  },
  computed: {
    ...mapState('cst', ['cstCollection']),
    ...mapState('csosn', ['csosnCollection']),
    ...mapState('origem', ['origemCollection']),
    ...mapState('unitOfMeasure', ['unitOfMeasureCollection']),
    ...mapState('componentsPurchase', ['modalProductIsOpen']),
    ...mapState('purchase', [
      'cfopCollection',
      'purchaseParams',
      'modalProductIsOpen',
      'supplierInformation',
      'productOfPurchaseOnFiscalEdit',
    ]),
  },
  methods: {
    ...mapActions('cst', ['setCSTCollection']),
    ...mapActions('csosn', ['setCSOSNCollection']),
    ...mapActions('origem', ['setOrigemCollection']),
    ...mapActions('purchase', ['setCfopCollectionForProductPurchase']),
    ...mapActions('unitOfMeasure', ['setUnitOfMeasureCollection']),
    ...mapActions('componentsPurchase', ['setLoadingTabProduct']),

    async searchCsosn(search = null) {
      if (search) {
        await this.setCSOSNCollection(search);
      }
    },
    changeCsosnSelected(selectedCsosn) {
      if (selectedCsosn) {
        this.productOfPurchaseOnFiscalEdit.fiscal.values.csosn = {
          ...selectedCsosn,
        };

        return;
      }

      this.productOfPurchaseOnFiscalEdit.fiscal.values.csosn = [];
    },
    async searchCfop(search = null) {
      await this.setCfopCollectionForProductPurchase({
        search,
        supplierId: this.supplierInformation.supplier.id,
      });
    },
    changeCfopSelected(selectedCfop) {
      if (selectedCfop) {
        this.productOfPurchaseOnFiscalEdit.fiscal.values.cfop = {
          ...selectedCfop,
        };

        return;
      }

      this.productOfPurchaseOnFiscalEdit.fiscal.values.cfop = [];
    },
    async searchOrigem(search = null) {
      if (search) {
        await this.setOrigemCollection(search);
      }
    },
    changeOrigemSelected(selectedOrigem) {
      if (selectedOrigem) {
        this.productOfPurchaseOnFiscalEdit.fiscal.values.origem = {
          ...selectedOrigem,
        };

        return;
      }

      this.productOfPurchaseOnFiscalEdit.fiscal.values.origem = [];
    },
    async searchCst(search = null) {
      if (search) {
        await this.setCSTCollection(search);
      }
    },
    changeCstSelected(selectedCst) {
      if (selectedCst) {
        this.productOfPurchaseOnFiscalEdit.fiscal.values.cst = {
          ...selectedCst,
        };

        return;
      }

      this.productOfPurchaseOnFiscalEdit.fiscal.values.cst = [];
    },
    async searchUnitOfMeasure(search = null) {
      if (search) {
        this.setLoadingTabProduct(true);
        await this.setUnitOfMeasureCollection(search);
        this.setLoadingTabProduct(false);
      }
    },
    changeUnitOfMeasure(selected) {
      if (selected) {
        this.productOfPurchaseOnFiscalEdit.productData.unitOfMeasure = {
          ...selected,
        };
      }
    },
    converterOperationDivider() {
      const result =
        this.valorUS(this.productOfPurchaseOnFiscalEdit.productData.quantityPurchased) /
        this.productOfPurchaseOnFiscalEdit.productData.unitOfMeasure.converter;

      return round(result, this.purchaseParams.decimalConfiguration.quantity);
    },
    converterOperationMultiplier() {
      const result =
        this.valorUS(this.productOfPurchaseOnFiscalEdit.productData.quantityPurchased) *
        this.productOfPurchaseOnFiscalEdit.productData.unitOfMeasure.converter;

      return round(result, this.purchaseParams.decimalConfiguration.quantity);
    },
    returnsCharacterOperator(operator) {
      return operator === MULTIPLIER ? 'x' : '/';
    },
    labelQuantity() {
      const { converterOperator } = this.productOfPurchaseOnFiscalEdit.productData.unitOfMeasure;

      if (converterOperator === MULTIPLIER) {
        return `Quantidade (entrada estoque: ${this.valorReal(
          this.converterOperationMultiplier(),
          this.purchaseParams.decimalConfiguration.quantity,
        )})`;
      }

      return `Quantidade (entrada estoque: ${this.valorReal(
        this.converterOperationDivider(),
        this.purchaseParams.decimalConfiguration.quantity,
      )})`;
    },
    updateTotalPrice() {
      const { price, discount, quantityPurchased } = this.productOfPurchaseOnFiscalEdit.productData;

      const formattedPrice = this.valorUS(price);
      const formattedDiscount = this.valorUS(discount) ?? 0;
      const formattedQuantityPurchased = this.valorUS(quantityPurchased);
      const totalPrice = new MathUtils(formattedPrice)
        .multiply(formattedQuantityPurchased)
        .subtract(formattedDiscount)
        .round(2)
        .toNumber();

      this.productOfPurchaseOnFiscalEdit.productData.totalPrice = this.valorReal(totalPrice);
    },
    onChangeQuantityPurchased(value) {
      this.productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.IS.qTrib = numberBRToFloat(value);
    },
  },
  watch: {
    productOfPurchaseOnFiscalEdit: {
      handler() {
        this.updateTotalPrice();
        this.handleConverterOperation();
      },
      deep: true,
    },
  },
};
</script>
